import { createTheme } from '@mui/material/styles';

/**
 * Devuelve tokens de diseño según modo de color.
 * @param {'light' | 'dark'} mode
 */
export const getDesignTokens = (mode = 'light') => ({
  palette: {
    mode,
    ...(mode === 'light'
      ? {
          // PALETA LIGHT
          primary: {
            main: '#4e73df',
          },
          secondary: {
            main: '#1cc88a',
          },
          background: {
            default: '#f8f9fc',
            paper: '#ffffff',
          },
        }
      : {
          // PALETA DARK
          primary: {
            main: '#4e73df',
          },
          secondary: {
            main: '#1cc88a',
          },
          background: {
            default: '#121212',
            paper: '#1e1e1e',
          },
        }),
  },
  typography: {
    fontFamily: [
      'Inter',
      '-apple-system',
      'BlinkMacSystemFont',
      'Segoe UI',
      'Roboto',
      'Helvetica Neue',
      'Arial',
      'sans-serif',
    ].join(','),
  },
});

/**
 * Devuelve un objeto theme listo para ThemeProvider.
 * @param {'light' | 'dark'} mode
 */
export const getTheme = (mode) => createTheme(getDesignTokens(mode));
